{
	"domain-codes": {
		"activeEvaluationMeasureType": {
			"ISOLATION": {
				"abbreviation": "ISO",
				"display": "Mesures d’isolation actives"
			},
			"RESTRICTION": {
				"abbreviation": "MRL",
				"display": "Mesures de restriction de liberté actives"
			}
		},
		"assessmentStatus": {
			"NOT_PLANNED": {
				"display": "Non planifié"
			},
			"OPEN": {
				"display": "Ouvert {{relativeTime}}"
			},
			"PLANNED": {
				"display": "Planifié {{date}}"
			},
			"TODAY": {
				"display": "Aujourd'hui"
			}
		},
		"boolean": {
			"FALSE": {
				"display": "Non"
			},
			"TRUE": {
				"display": "Oui"
			}
		},
		"evaluationMeasureStatus": {
			"ACTIVE": {
				"display": "Actif"
			},
			"NEW": {
				"display": "Nouveau"
			},
			"STOPPED": {
				"display": "Stop"
			}
		},
		"followUpEvaluationMeasureStatus": {
			"ALTERNATIVE_ACTIVE": {
				"display": "Maintenir les mesures alternatives"
			},
			"ALTERNATIVE_MODIFIED": {
				"display": "Modifier les mesures alternatives"
			},
			"ALTERNATIVE_NEW": {
				"display": "Mettre en place les mesures alternatives"
			},
			"ALTERNATIVE_NONE": {
				"display": "Ne pas mettre en place les mesures alternatives"
			},
			"ALTERNATIVE_STOPPED": {
				"display": "Arrêter les mesures alternatives"
			},
			"ISOLATION_ACTIVE": {
				"display": "Maintenir les mesures d’isolement"
			},
			"ISOLATION_MODIFIED": {
				"display": "Modifier les mesures d’isolement"
			},
			"ISOLATION_NEW": {
				"display": "Mettre en place les mesures d’isolement"
			},
			"ISOLATION_NONE": {
				"display": "Ne pas mettre en place les mesures d’isolement"
			},
			"ISOLATION_STOPPED": {
				"display": "Arrêter les mesures d’isolement"
			},
			"NO_MEASURES": {
				"display": "Ne pas mettre en place de mesures"
			},
			"RESTRICTION_ACTIVE": {
				"display": "Maintenir les mesures restrictives"
			},
			"RESTRICTION_MODIFIED": {
				"display": "Modifier les mesures restrictives"
			},
			"RESTRICTION_NEW": {
				"display": "Mettre en place les mesures restrictives"
			},
			"RESTRICTION_NONE": {
				"display": "Ne pas mettre en place les mesures restrictives"
			},
			"RESTRICTION_STOPPED": {
				"display": "Arrêter les mesures restrictives"
			},
			"UNKNOWN_MEASURES": {
				"display": "Mesures inconnues"
			}
		},
		"followUpPlanStatus": {
			"CLOSED": {
				"display": "Finalisé le {{date}}"
			},
			"NOT_PLANNED": {
				"display": "Suivi à planifier"
			},
			"OVERDUE": {
				"display": "Suivi {{relativeTime}}"
			},
			"PLANNED": {
				"display": "Suivi le {{date}}"
			},
			"TODAY": {
				"display": "Suivi aujourd’hui"
			}
		}
	}
}
